export enum ETypeDay {
  default = 'deafault',
  holiday = 'holiday',
  vacation = 'vacation',
}
export enum ETypeTask {
  ownEvent = 'Own Event',
  applicationMeeting = 'Application Meeting',
  freeSlot = 'Free Slot',
}
